import { couponLen } from "@configs";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupRedeem = () => {
  const { t } = useTranslation();
  return {
    couponCode: Yup.string()
      .required(
        t("validation.required", {
          couponCode: t("page.couponCode"),
        })
      )
      .length(couponLen),
    doctorName: Yup.string().required(
      t("validation.required", {
        doctorName: t("page.providerName"),
      })
    ),
  };
};
